import CreditCardTemplate from 'components/CreditCardTemplate';
import { getDate } from 'helper/date';
import { CreditCardProps } from './createCard.interface';
import * as S from './createCard.styles';

const CreditCard = ({ type, name, date, idNumber, color }: CreditCardProps) => (
  <S.Wrapper

  // style={{ backgroundImage: `url(/passenger/images/static/${type.toLowerCase()}-card.svg)` }}
  >
    <CreditCardTemplate color={color} />
    <S.User>
      <S.UserName>{name}</S.UserName>
      <S.UserNumber>{idNumber}</S.UserNumber>
      <S.UserDate>
        EXP DATE | <S.UserDateSpan>{getDate(new Date(date))}</S.UserDateSpan>
      </S.UserDate>
    </S.User>
  </S.Wrapper>
);

export default CreditCard;
